import Vue from 'vue'

//  TOOLBARS 
import pageTab from '../components/mbs_toolbars/pageTab' 
//  SECTION 
import showTab from '../components/mbs_sections/showTab' 
import pageSpinner from '../components/mbs_sections/pageSpinner' 
import itemManager from '../components/mbs_sections/itemManager'  
import inputFields from '../components/mbs_sections/inputFields'  
import keyboard from '../components/mbs_sections/keyboard'  
import questionnaire from '../components/mbs_sections/questionnaire'  
import actionsField from '../components/mbs_sections/actionsField'  
import accessPage from '../components/mbs_sections/accessPage' 
import accessLogin from '../components/mbs_sections/accessLogin'   
import showLogo from '../components/mbs_sections/showLogo' 

// MENUS 
import dialog from '../components/mbs_menus/dialog' 
import dialogInput from '../components/mbs_menus/dialogInput' 
import progressDialog from '../components/mbs_menus/progressDialog'
import snackbar from '../components/mbs_menus/snackbar' 
import excelSelecter from '../components/not_file_selecter/excelSelecter' 

 


//  TOOLBARS 
Vue.component('mbs-page-tab',pageTab)  
//  SECTION 
Vue.component('mbs-show-tab',showTab)
Vue.component('mbs-page-spinner',pageSpinner)
Vue.component('mbs-item-manager',itemManager) 
Vue.component('mbs-input-fields',inputFields) 
Vue.component('mbs-keyboard',keyboard) 
Vue.component('mbs-questionnaire',questionnaire) 
Vue.component('mbs-actions-field',actionsField) 
Vue.component('mbs-access-page',accessPage)
Vue.component('mbs-access-login',accessLogin)   
Vue.component('mbs-show-logo',showLogo)   
//MENUS 
Vue.component('mbs-dialog',dialog)
Vue.component('mbs-dialog-input',dialogInput)
Vue.component('mbs-dialog-progress',progressDialog)
Vue.component('mbs-snackbar',snackbar) 
Vue.component('mbs-excel-selector',excelSelecter) 

 